export default from './ExpandableImage';



// WEBPACK FOOTER //
// ./src/elements/expandable-image/index.jsx